export interface OtherOrder {
	id: number;
	client: {
		name: string;
		phone: string;
	};
	name: string;
	value: number;
	value_type: 0 | 1;
	date: string;
	comments: string | null;
	created_by: boolean;
}
